"use client";

import React, { useRef, useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const CORE_VALUES = ["NO SPONSORS", "NO CLINICS", "JUST SCIENCE", "UNBIASED TRUTH", "PATIENT FIRST"];
const Manifesto = () => {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  return <div ref={ref as React.RefObject<HTMLDivElement>} className={cn("mx-auto mt-32 max-w-2xl px-6 text-center transition-all duration-1000 ease-out md:mt-48", isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0")}>
      <div className="font-sans text-lg leading-relaxed text-muted-foreground md:text-xl">
        <p className="mb-6">
          OralGuide is an anonymous, professional educational blog dedicated to
          simplifying dental health for the general public. We deliver
          high-quality, evidence-based guides on oral hygiene, dental
          procedures, and common myths.
        </p>
        <p className="mb-6">
          Our content serves as an independent informational hub, completely
          unlinked to any specific clinical practice. We believe in
          authoritative, trustworthy, and calming education—using clean,
          abstract illustrations instead of clinical photography to create a
          reassuring environment.
        </p>
        <p className="mb-12">
          This is our pledge: to empower your journey with clarity, confidence,
          and unbiased science.
        </p>
      </div>
      <div className="border-t border-border pt-8">
        <p className="font-serif text-2xl italic text-foreground">
          — The OralGuide Team
        </p>
      </div>
    </div>;
};
const ValueItem = ({
  text,
  index
}: {
  text: string;
  index: number;
}) => {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.5,
    once: false,
    rootMargin: "-10% 0px -10% 0px"
  });
  return <div ref={ref as React.RefObject<HTMLDivElement>} data-index={index} className={cn("flex min-h-[40vh] items-center justify-center transition-all duration-1000 ease-in-out md:min-h-[50vh]", isVisible ? "opacity-100 blur-0" : "opacity-10 blur-sm")}>
      <h2 className="text-center font-serif text-6xl font-bold tracking-tighter text-white md:text-8xl lg:text-9xl">
        {text}
      </h2>
    </div>;
};
export default function APledgeOfIndependence() {
  return <section id="a-pledge-of-independence" className="dark bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
        <div className="bg-primary/5 h-[50vh] w-[50vw] rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 container mx-auto">
        {}
        <div className="flex flex-col gap-12 md:gap-24">
          {CORE_VALUES.map((value, i) => <ValueItem key={i} text={value} index={i} />)}
        </div>

        {}
        <Manifesto />
      </div>
    </section>;
}